import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilterMetaYearResponseDto } from '../../types/response';
import KpiWeekSelector from './kpi-week-selector';

interface KpiWeekSelectorWrapperProps {
  years: FilterMetaYearResponseDto[];
  currentYear: number;
  currentWeek: number;
  disabled?: boolean;
}

const KpiWeekSelectorWrapper = ({ years, currentYear, currentWeek, disabled }: KpiWeekSelectorWrapperProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const yearParam = searchParams.get('year');
  const weekParam = searchParams.get('week');

  const parsedYear = yearParam ? Number(yearParam) : currentYear;
  const parsedWeek = weekParam ? Number(weekParam) : currentWeek;

  const yearOptions = years.map((y) => y.year);
  const weekOptions = years.find((y) => y.year === parsedYear)?.weeks ?? [];

  const isValid = yearOptions.includes(parsedYear) && weekOptions.includes(parsedWeek);

  const currentWeekOptions = years.find((y) => y.year === currentYear)?.weeks ?? [];
  const isCurrentValid = yearOptions.includes(currentYear) && currentWeekOptions.includes(currentWeek);

  const selectedYear = isValid ? parsedYear : currentYear;
  const selectedWeek = isValid ? parsedWeek : currentWeek;

  useEffect(() => {
    if (!isValid && isCurrentValid) {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.set('year', String(currentYear));
        params.set('week', String(currentWeek));
        return params;
      });
    }
  }, [isValid, isCurrentValid, currentYear, currentWeek, setSearchParams]);

  const onChangeHandler = (week: string, year: string) => {
    if (week === String(selectedWeek) && year === String(selectedYear)) return;

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set('week', week);
      params.set('year', year);
      return params;
    });
  };

  if (!isCurrentValid) return;

  return <KpiWeekSelector years={years} currentYear={selectedYear} currentWeek={selectedWeek} disabled={disabled} onChange={onChangeHandler} />;
};

export default KpiWeekSelectorWrapper;
